<script>

    import panzoom from 'panzoom';

    import TubeStatics from './TubeStatics.svelte'
    import RentChart from './RentChart.svelte';
    import Toggle from './Toggle.svelte';
    import Faq from './Faq.svelte';

    export let data;
    export let initialWindowWidth;

    let instance

    const ratioFactor = 0.72727309171

    $: windowWidth = 0;

    $: isMobile = windowWidth < 900 ? true : false;
    $: fullWidth = 0;
    $: fullHeight = fullWidth * ratioFactor;

    $: width = fullWidth;
    $: height = width * ratioFactor;

    $: console.log("IS MOBILE", isMobile)

	function initPanzoom(node) {
		if (initialWindowWidth < 900) { 
            instance = panzoom(node, {
                minZoom: 1,
                initialZoom: 10,
                initialX: 200,
                initialY: 200 / 2
            })
        } else {
            instance = panzoom(node, {
                minZoom: 1,
                initialZoom: 2,
                initialX: 600,
                initialY: 600
            })
        }
        // instance = panzoom(node)
        // instance.zoomIn(10)
        console.log("PANZOOM INSTANCE", instance)
        // instance.zoomTo(fullWidth, fullHeight, 10)
	}


    function formatNumberWithCommas(number) {
  if (typeof number !== 'number') {
    throw new TypeError('Input must be a number');
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

    let selectedStation = false;

    $: console.log(selectedStation)

    let showRent = false;

    function switchMetrics() {
        showRent = !showRent
    }

    // $: toggleOverlay = false;

    function selectStationMobile(station) {
        if (isMobile) {
            console.log("pointer down!")
            selectedStation = station;
        }
    }

    let showFAQ = false;

    function displayFaq() {
        showFAQ = true
        if (isMobile) {
            selectedStation = false;
        }
    }
    // width="1247.244px"
        // height="907.087px" 

</script>

<style>

    svg {
        z-index: -1;
        overflow: hidden;
    }

    .map-con {
        overflow: hidden;
        background-color: white;
        width: 100%;
        height: 100vh
        /* margin-top: 25vh; */
    }
/* 
    .overlay-con {
        width: 100vw;
        height: 100vh;
    } */

    .station-label {
        font-size: 3px;
        cursor: pointer;
    }

    /* .station-label:hover {
        text-decoration: underline;
    } */

    .big {
        font-size: 5px;
    }

    .halo {
        fill:white;
        stroke: white;
        stroke-width: 1
    }

    .small {
        font-size: 2px;
    }

    .overlay {
        position: fixed;
        top: 10px;
        right: 10px;
        width: 300px;
        border: 2px solid black;
        padding: 10px;
        background-color: white;
        /* pointer-events: auto; */
        z-index: 10000;
    }

    .overlay-spy {
        position: fixed;
        bottom: 10px;
        right: 10px;
        border: 2px solid black;
        padding: 10px;
        max-width: 400px;
        font-size: 14px;
        background-color: white;
        /* pointer-events: auto; */
        z-index: 10000;
    }

    .info {
        font-size: 14px;
        margin-bottom: 4px;
    }


    .station-info {
        position: fixed;
        top: 10px;
        left: 10px;
        border: 2px solid black;
        padding: 10px;
        width: 350px;
        background-color: white;
        /* pointer-events: auto; */
        z-index: 10000;
    }


      @media (max-width: 900px) {
        /* .overlay {
            left: 50%;
            width: 90%;
            transform: translate(-50%, 0%);
            width: 100%;
        } */
        .overlay {
            top: 1vh;
            left: 2vw;
            width: 96vw;
            box-sizing: border-box;
        }
        .overlay-spy {
            /* left: 50%; */
            /* transform: translate(-50%, 0%); */
            /* width: 100%; */
            /* width: 90%; */
            /* text-align: center; */
            bottom: 1vh;
            left: 2vw;
            text-align: center;
            width: 96vw;
            font-size: 11px;
            padding: 5px;
            box-sizing: border-box;
        }
        .info {
            font-size: 14px;
        }

        .station-info {
            left: 2vw;
            width: 96vw;
            top: 1vh;
            box-sizing: border-box;
            /* transform: translate(-50%, 0%); */
            /* width: 90%; */
        }
    }

   
    .bold {
        font-weight: 700;
    }

 

    .station-name {
        font-size: 32px;
        font-weight: 700;
    }

    .key-stats {
        margin-top: 8px;
        display: flex;
        border-top: 1px solid #D9D9D9;
        padding-top: 8px;
    }

    .key-stat {
        width: 45%;
        margin-right: 8px;
        border-right: 1px solid #D9D9D9;
    }

    .key-stat:last-child {
        border-right: none;
    }

    .stat {
        font-size: 24px;
        font-weight: 700;
    }

    .label {
        font-size: 14px;
        /* font-style: italic; */
        color: #767676;
    }

    .rise {
        fill: #C70000;
        color: #C70000;
    }

    .fall {
        fill: #157F1F;
        color: #157F1F;
    }

    .postcode-district {
        font-size: 14px;
        color: #767676;
    }

    .not-available {
        margin-top: 16px;
    }

    .tiny-logo {
        width: 14px;
        margin-right: 4px;
    }

    .station-info-header {
        display: flex;
        justify-content: space-between;
    }

    .station-info-close {
        cursor: pointer;
    }



</style>

<svelte:window bind:innerWidth={windowWidth} />

<div class='map-con' bind:clientWidth={fullWidth}>
   

    <svg 
        id="status-map" 
        version="1.1" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink" 
        x="0px" y="0px" 
        width={width}
        height={height}
        viewBox="64.094 122.25 985.889 657.072"
        enable-background="new 0 0 1247.244 907.087"
        xml:space="preserve"
        use:initPanzoom
    
    >
    <!-- use:initPanzoom -->
        <TubeStatics />

        <g id='station-names'>
            {#each data as station}
                <!-- <text
                    transform={station.transform}
                    class='station-label halo'
                    x={0}
                    y={0}
                >
                    <tspan class='big' x=0 y=0 dy={0}>£{station.rent}</tspan>
                    <tspan x=0 y=0 dy={5}>{station.text}</tspan>
                </text> -->
                <text
                    transform={station.transform}
                    class='station-label halo'
                    on:click={(e) => selectedStation = station}
                >
                    <tspan x=0>{station.text}</tspan>
                    {#if station.rent != 'Not enough data' && station.rent != 'Not in London'}
                        {#if !showRent}
                            <tspan x=0 dy={5} class='big'>£{formatNumberWithCommas(Number(station.rent))}</tspan>
                        {:else}
                          
                                {#if station.hike > 0}
                                <tspan x=0 dy={5} class='big' >+£{station.hike}</tspan>
                                {:else if station.hike < 0}
                                <tspan x=0 dy={5} class='big' >-£{Math.abs(station.hike)}</tspan>
                                {:else if station.hike === 0}
                                <tspan x=0 dy={5} class='big' >£0</tspan>
                                {:else}
                                <tspan x=0 dy={3} class='small'>Not enough data</tspan>
                                {/if}
                            
                        {/if}
                    {:else}
                    <tspan x=0 dy={3} class='small'>{station.rent == 'Not in London' ? '' : station.rent}</tspan>
                    {/if}
                </text>
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <text
                    transform={station.transform}
                    class='station-label'
                    on:click={(e) => selectedStation = station}
                    on:pointerdown={(e) => isMobile ? selectedStation = station : ""}
                >
                    <tspan x=0>{station.text}</tspan>
                    {#if station.rent != 'Not enough data' && station.rent != 'Not in London'}
                        {#if !showRent}
                            <tspan x=0 dy={5} class='big'>£{formatNumberWithCommas(Number(station.rent))}</tspan>
                            {:else}
                          
                            {#if station.hike > 0}
                            <tspan x=0 dy={5} class='big rise' >+£{station.hike}</tspan>
                            {:else if station.hike < 0}
                            <tspan x=0 dy={5} class='big fall' >-£{Math.abs(station.hike)}</tspan>
                            {:else if station.hike === 0}
                            <tspan x=0 dy={5} class='big' >£0</tspan>
                            {:else}
                            <tspan x=0 dy={3} class='small'>Not enough data</tspan>
                            {/if}
                        
                    {/if}
                    {:else}
                    <tspan x=0 dy={3} class='small'>{station.rent == 'Not in London' ? '' : station.rent}</tspan>
                    {/if}
                    <!-- {#each station.text.split(' ') as text, i} -->
                    <!-- {/each} -->
                </text>
                <!-- <text
                    transform={station.transform}
                    fill='red'
                    class='station-label'
                >
                    XXXXXXXX
                </text> -->
                <!-- <text
                    transform={station.transform}
                    class='station-label'
                    text-anchor='middle'
                    x={0}
                    y={0}
                >
                    {station.text}: £{station.rent}
                </text> -->
            {/each}
        </g>
    
    </svg>
    
   

</div>

<div class='overlay-con'>

{#if (!isMobile) || (isMobile && !selectedStation)}
<div class='overlay'>
    {#if !isMobile}<div class='bold info'>FYI:</div>{/if}
    <div class='info'>👆 Pan and zoom to explore the map</div>
    <div class='info'>📈 Toggle to show rent rises since 2019</div>
    <div class='info'>🔍 Click/tap a station for more detail</div>
    <div class='info'>❓ <a on:click={(e) => displayFaq()}>Read our FAQs</a> to understand the data</div>
    <Toggle on:option-changed={(e) => switchMetrics()} />
</div>

<div class='overlay-spy'>
    <div class=''>Created by <i>London Spy</i>. <a href="https://www.thelondonspy.co.uk/">Sign up for more cool London stuff</a>.</div>    
</div>
{/if}

{#if selectedStation}
<div class='station-info'>
    <div class='station-info-header'>
        <div class='station-info-title'>
            <div class='station-name'>{selectedStation.text}</div>
            <div class='postcode-district'>Postcode district: {selectedStation.code}</div>
        </div>
        <div class='station-info-close' on:click={() => selectedStation = false}>
            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 26 26" width="26px" height="26px"><path d="M 21.734375 19.640625 L 19.636719 21.734375 C 19.253906 22.121094 18.628906 22.121094 18.242188 21.734375 L 13 16.496094 L 7.761719 21.734375 C 7.375 22.121094 6.746094 22.121094 6.363281 21.734375 L 4.265625 19.640625 C 3.878906 19.253906 3.878906 18.628906 4.265625 18.242188 L 9.503906 13 L 4.265625 7.761719 C 3.882813 7.371094 3.882813 6.742188 4.265625 6.363281 L 6.363281 4.265625 C 6.746094 3.878906 7.375 3.878906 7.761719 4.265625 L 13 9.507813 L 18.242188 4.265625 C 18.628906 3.878906 19.257813 3.878906 19.636719 4.265625 L 21.734375 6.359375 C 22.121094 6.746094 22.121094 7.375 21.738281 7.761719 L 16.496094 13 L 21.734375 18.242188 C 22.121094 18.628906 22.121094 19.253906 21.734375 19.640625 Z"/></svg>
        </div>
    </div>
    {#if !selectedStation.rent.split(' ').includes("Not")}
    <div class='key-stats'>
        <div class='key-stat'>
            <div class='stat'>
                £{formatNumberWithCommas(Number(selectedStation.rent))}
            </div>
            <div class='label'>
                Monthly rent for a one-bed in 2024
            </div>    
        </div>
        <div class='key-stat'>
            <div class='stat' class:rise={selectedStation.hike > 0} class:fall={selectedStation.hike < 0}>
                {#if selectedStation.hike > 0}
                    +£{selectedStation.hike}
                {:else if selectedStation.hike < 0}
                    -£{Math.abs(selectedStation.hike)}
                {:else if selectedStation.hike === 0}
                    £0
                {:else}
                    —
                {/if}
            </div>
            <div class='label'>
                Change in monthly rent for one-bed since 2019
            </div>    
        </div>
    </div>
    <RentChart timeSeries={selectedStation.time_series} average={selectedStation.time_series_avg} stationName={selectedStation.text}  {isMobile} />
    {:else}
        <div class='not-available'>Not enough data. Read our FAQ for more info.</div>
    {/if}
</div>
{/if}

{#if showFAQ}
    <Faq on:close-faq={(e) => showFAQ = false} />
{/if}

</div>